import React, { useState, useEffect } from 'react';
import { CloseIcon } from '../Icons/Icons';
import './AreaConverter.css';

function AreaConverter({ onClose }) {
  const [fromValue, setFromValue] = useState(1);
  const [fromUnit, setFromUnit] = useState('marla');
  const [toUnit, setToUnit] = useState('sqft');
  const [result, setResult] = useState(0);

  const units = {
    sqft: { name: 'Square Feet', multiplier: 1 },
    sqyd: { name: 'Square Yards', multiplier: 9 },
    sqm: { name: 'Square Meters', multiplier: 10.764 },
    marla: { name: 'Marla', multiplier: 272.25 },
    kanal: { name: 'Kanal', multiplier: 5445 },
    acre: { name: 'Acre', multiplier: 43560 }
  };

  useEffect(() => {
    convertArea();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromValue, fromUnit, toUnit]);

  const convertArea = () => {
    const value = parseFloat(fromValue) || 0;

    // Convert to square feet first (base unit)
    const inSqFt = value * units[fromUnit].multiplier;

    // Convert from square feet to target unit
    const converted = inSqFt / units[toUnit].multiplier;

    setResult(converted);
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-PK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 4
    }).format(num);
  };

  const swapUnits = () => {
    setFromUnit(toUnit);
    setToUnit(fromUnit);
  };

  return (
    <div className="converter-modal-overlay" onClick={onClose}>
      <div className="converter-modal" onClick={(e) => e.stopPropagation()}>
        <div className="converter-header">
          <h2>Area Unit Converter</h2>
          <button className="btn-close" onClick={onClose} aria-label="Close converter">
            <CloseIcon size={24} color="#636e72" />
          </button>
        </div>

        <div className="converter-body">
          <div className="converter-container">
            <div className="converter-section">
              <label htmlFor="from-value">From</label>
              <div className="converter-input-group">
                <input
                  id="from-value"
                  type="number"
                  value={fromValue}
                  onChange={(e) => setFromValue(e.target.value)}
                  className="converter-input"
                  min="0"
                  step="any"
                />
                <select
                  value={fromUnit}
                  onChange={(e) => setFromUnit(e.target.value)}
                  className="converter-select"
                >
                  {Object.keys(units).map(unit => (
                    <option key={unit} value={unit}>
                      {units[unit].name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <button className="btn-swap" onClick={swapUnits} aria-label="Swap units">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M7 10L12 15L17 10"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17 14L12 9L7 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <div className="converter-section">
              <label htmlFor="to-unit">To</label>
              <div className="converter-input-group">
                <input
                  type="text"
                  value={formatNumber(result)}
                  className="converter-input"
                  readOnly
                />
                <select
                  id="to-unit"
                  value={toUnit}
                  onChange={(e) => setToUnit(e.target.value)}
                  className="converter-select"
                >
                  {Object.keys(units).map(unit => (
                    <option key={unit} value={unit}>
                      {units[unit].name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="conversion-result">
            <div className="result-text">
              {formatNumber(fromValue)} {units[fromUnit].name} = {formatNumber(result)} {units[toUnit].name}
            </div>
          </div>

          <div className="conversion-table">
            <h3>Quick Reference ({fromValue} {units[fromUnit].name})</h3>
            <div className="table-grid">
              {Object.keys(units).map(unit => {
                if (unit === fromUnit) return null;
                const inSqFt = parseFloat(fromValue) * units[fromUnit].multiplier;
                const converted = inSqFt / units[unit].multiplier;
                return (
                  <div key={unit} className="table-row">
                    <span className="table-unit">{units[unit].name}</span>
                    <span className="table-value">{formatNumber(converted)}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AreaConverter;
